import { ptBR, enUS, es } from 'date-fns/locale';

export function getDateTimeLocale(locale: string) {
    const locales = {
        'pt': ptBR,
        'en': enUS,
        'es': es,
    };

    return locales[locale as 'pt' || 'en' || `es`] ?? enUS;
}

export function getDateFormats(locale: string) {
    const locales = {
        'pt': "dd'/'MM'/'yyyy",
        'en': "MM'/'dd'/'yyyy",
        'es': "dd'/'MM'/'yyyy",
    };

    return locales[locale as 'pt' || 'en' || `es`] ?? "dd'/'MM'/'yyyy";
}

export function getInputDateFormats(locale: string) {
    const locales = {
        'pt': "dd/MM/yyyy",
        'en': "MM/dd/yyyy",
        'es': "dd/MM/yyyy",
    };

    return locales[locale as 'pt' || 'en' || `es`] ?? "dd'/'MM'/'yyyy";
}

export function getDateTimeFormats(locale: string) {
    const locales = {
        'pt': "dd'/'MM'/'yyyy '-' HH:mm'h'",
        'en': "MM'/'dd'/'yyyy '-' h:mm a",
        'es': "dd'/'MM'/'yyyy '-' HH:mm'h'",
    };

    return locales[locale as 'pt' || 'en' || `es`] ?? "dd'/'MM'/'yyyy";
}

export function getTimeFormats(locale: string) {
    const locales = {
        'pt': "HH:mm",
        'en': "h:mm a",
        'es': "HH:mm",
    };

    return locales[locale as 'pt' || 'en' || `es`] ?? "dd'/'MM'/'yyyy";
}
